import React from 'react'

import {useParams} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import OrderSection from '../components/orderSection'

export default function Orders() {
  
  const {email} = useParams();
  const getDate = new Date();

  return (
    <>
        <InactivityLogout>
        <Header searchterm={email} />
        <OrderSection searchterm={email} getDate={getDate}  />
        </InactivityLogout>
    </>
  )
}
